import { gray } from '../../components/Color';
import { FlexGrid } from '../../components/FlexGrid';
import { MovingGradient } from '../../components/MovingGradient';
import { PaddingBox } from '../../components/PaddingBox';

function AuthenticationLoginPreload() {
	return (
		<FlexGrid
			center
			style={{
				flex: '1 1 auto',
				backgroundColor: gray[0],
			}}
		>
			<PaddingBox
				small
				style={{
					width: '354px',
					height: '317px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					margin: '0 auto',
					maxWidth: '352px',
					backgroundColor: 'var(--oc-white)',
					border: '1px solid var(--oc-gray-2)',
					borderRadius: '4px',
				}}
			>
				<div>
					<MovingGradient
						height='27px'
						width='150px'
					/>
					<PaddingBox topNormal>
						<MovingGradient
							height='64px'
							width='320px'
						/>
					</PaddingBox>
					<PaddingBox topSmall>
						<MovingGradient
							height='64px'
							width='320px'
						/>
					</PaddingBox>
				</div>
				<MovingGradient
					height='32px'
					width='320px'
				/>
			</PaddingBox>
		</FlexGrid>
	);
}

export { AuthenticationLoginPreload };
